import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';


/*
The frontend mainly serves the interface for mybarre staff member to determine what to send to classpass
There are two pages in total for now:
1. Class Description assign (send class templates): DescriptionPage.js, DescriptionList.js
2. Class assign (send classes): AssignSpotsPage.js, ClassList.js, ConfirmationPopup.js
The other files are shared
*/

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
